export const MenuItems = [
	{
		title: 'Home',
		url:"home",
		cName:'nav-links',
	},
	{
		title: 'Portofolio',
		url:'portofolio',
		cName:'nav-links',
	},
	{
		title: 'Service',
		url:'service',
		cName:'nav-links'
	},
	{
		title: 'Contact me',
		url: '#offer',
		cName: 'nav-links-mobile'
	}
]